import { Box, Button, Heading, HStack, Text, useColorModeValue, VStack } from "@chakra-ui/react";
import { FaChartLine, FaFlask, FaVial } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

/**
 * A component that provides quick access to health metric tabs from the home page
 */
const QuickAccessCard = () => {
  const navigate = useNavigate();
  const bgColor = useColorModeValue("white", "gray.700");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const textColor = useColorModeValue("gray.600", "gray.400");

  const handleViewHealthMetrics = () => {
    navigate("/health-metrics");
  };

  return (
    <Box borderWidth="1px" borderRadius="lg" borderColor={borderColor} bg={bgColor} p={4} shadow="md" height="100%">
      <VStack spacing={4} align="stretch">
        <Heading size="md" mb={2}>
          Health Metrics
        </Heading>
        <Text fontSize="sm" color="gray.500">
          Quick access to your health metrics analysis tools
        </Text>

        <Button
          leftIcon={<FaChartLine size={20} />}
          onClick={handleViewHealthMetrics}
          justifyContent="flex-start"
          variant="outline"
          size="md"
          borderRadius="md"
          py={6}
          _hover={{ bg: useColorModeValue("gray.100", "gray.600") }}
          width="100%"
        >
          <Text fontWeight="semibold">Calculate Health Metrics</Text>
        </Button>

        <HStack spacing={3} mt={2} px={2}>
          <HStack spacing={1}>
            <FaFlask size={14} color={useColorModeValue("#3182CE", "#63B3ED")} />
            <Text fontSize="sm" color={textColor}>
              RBTI Analysis
            </Text>
          </HStack>
          <Text fontSize="sm" color={textColor}>
            •
          </Text>
          <HStack spacing={1}>
            <FaVial size={14} color={useColorModeValue("#3182CE", "#63B3ED")} />
            <Text fontSize="sm" color={textColor}>
              pH Tools
            </Text>
          </HStack>
        </HStack>
      </VStack>
    </Box>
  );
};

export default QuickAccessCard;
